import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var createDiff = function createDiff(left, right) {
  return Object.entries(left).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return (right === null || right === void 0 ? void 0 : right[key]) !== value ? _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, right === null || right === void 0 ? void 0 : right[key])) : acc;
  }, {});
};
var createSubscriberContext = function createSubscriberContext(context, selectors) {
  return selectors.reduce(function (a, selector) {
    return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, selector, context === null || context === void 0 ? void 0 : context[selector]));
  }, {});
};
var idenityMiddleware = function idenityMiddleware(context) {
  return context;
};
export var createContextStore = function createContextStore(config) {
  var _config$middleware;
  var initialState = config === null || config === void 0 ? void 0 : config.initialState;
  var middleware = (_config$middleware = config === null || config === void 0 ? void 0 : config.middleware) !== null && _config$middleware !== void 0 ? _config$middleware : idenityMiddleware;
  var state = middleware(_objectSpread({
    tenantId: undefined,
    isSiteAdmin: undefined,
    product: undefined,
    subproduct: undefined,
    switcherMenuHasBeenOpened: undefined,
    sessionId: undefined,
    locale: undefined,
    orgId: undefined,
    workspaceId: undefined
  }, initialState));
  var subscribers = new Map();
  var updateSubscribers = function updateSubscribers(updatedContext, changes) {
    var changedKeys = Object.keys(changes);
    subscribers.forEach(function (selectors, subscription) {
      if (!selectors || changedKeys.find(function (changedKey) {
        return selectors.includes(changedKey);
      })) {
        updateSubscriber({
          subscription: subscription,
          context: updatedContext,
          subscriberContext: selectors ? createSubscriberContext(updatedContext, selectors) : updatedContext,
          changes: changes
        });
      }
    });
  };
  var updateSubscriber = function updateSubscriber(_ref3) {
    var subscription = _ref3.subscription,
      context = _ref3.context,
      subscriberContext = _ref3.subscriberContext,
      _ref3$changes = _ref3.changes,
      changes = _ref3$changes === void 0 ? {} : _ref3$changes;
    subscription({
      subscriberContext: subscriberContext,
      changes: changes,
      context: context
    });
  };
  var update = function update(callback) {
    var newState = middleware(callback(state));
    updateSubscribers(newState, createDiff(state, newState));
    state = newState;
  };
  var subscribe = function subscribe() {
    for (var _len = arguments.length, newSubscribers = new Array(_len), _key = 0; _key < _len; _key++) {
      newSubscribers[_key] = arguments[_key];
    }
    newSubscribers.forEach(function (newSubscriber) {
      var _newSubscriber = _slicedToArray(newSubscriber, 3),
        subscription = _newSubscriber[0],
        selectors = _newSubscriber[1],
        options = _newSubscriber[2];
      if (options !== null && options !== void 0 && options.updateOnSubscribe) {
        updateSubscriber({
          subscription: subscription,
          context: state,
          subscriberContext: selectors ? createSubscriberContext(state, selectors) : state
        });
      }
      subscribers.set(subscription, selectors);
    });
  };
  var unsubscribe = function unsubscribe(subscription) {
    !!subscription ? subscribers.delete(subscription) : subscribers.clear();
  };
  var getCurrentContext = function getCurrentContext() {
    return state;
  };
  return {
    update: update,
    subscribe: subscribe,
    getCurrentContext: getCurrentContext,
    unsubscribe: unsubscribe
  };
};